import dayjs, { Dayjs } from 'dayjs'

export const dateFormat = (date: Dayjs | Date | string) => {
  if (date) {
    return dayjs(date).format('DD/MM/YYYY')
  }

  return null
}
